export default __webpack_public_path__ + "static/media/suliac-outside-min.e2a95320.jpg";